(function () {
  class SettingsMenu extends PIXI.Container {
    constructor(json) {
      super();

      this._json = json;

      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
      messageBus.subscribe("ui:modal", this.onUIModal.bind(this));
      messageBus.subscribe(
        "game:settingMenuClosed",
        this.onSettingMenuClosed.bind(this)
      );

      this.visible = false;
    }

    initialise() {
      resourceManager.get(
        "sideMenu:sideMenuPanel:sideMenuContainer:buttonsContainer:settingsMenu:highlight"
      ).visible = false;

      this._closeButton = resourceManager.get(this._json.closeButtonId);

      this._closeButton.mousedown = this._closeButton.touchstart = function () {
        messageBus.postImmediate("game:settingMenuClosed", {});
        messageBus.postImmediate("game:sideMenuClosed", {});
      };

      const self = this;
      const volumeButton = resourceManager.get("uiContainer:bg:volume");
      const canEnableSound = this._activeButtons.btnSound.visible;
      volumeButton.canShowBase = volumeButton.canShow;
      volumeButton.canShow = function () {
        return (
          volumeButton.canShowBase() && self._activeButtons.btnSound.visible
        );
      };

      const volume_portrait = resourceManager.get(
        "buttonContainerMobile:reflexButtonBar:volume_portrait"
      );
      volume_portrait.canShowBase = volume_portrait.canShow;
      volume_portrait.canShow = function () {
        return (
          volume_portrait.canShowBase() && self._activeButtons.btnSound.visible
        );
      };

      const soundButton = resourceManager.get(
        "settingsMenu:settingsMenuPanel:bg:settingSound"
      );

      soundButton.alpha = canEnableSound ? 1 : 0.3;
      soundButton.setActive(canEnableSound);
    }

    onGameConfigEvent(config) {
      this._activeButtons = config.data.uiElements;

      //this._activeButtons.btnSound.visible = false;

      this.initialise();
    }

    onUIModal(event) {
      switch (event.reason) {
        case "History open":
        case "Help pages open":
        case "Game Rules open": {
          if (this.visible) {
            messageBus.postImmediate("game:settingMenuClosed", {
              reason: event.reason,
            });
          }
          break;
        }
        case "Settings open": {
          resourceManager.get(
            "sideMenu:sideMenuPanel:sideMenuContainer:buttonsContainer:settingsMenu:highlight"
          ).visible = true;
          this._closeButton.interactive = true;
          this.visible = true;
          messageBus.postImmediate("game:modal", {
            reason: "Settings menu open",
          });
          break;
        }
      }
    }

    onSettingMenuClosed(event) {
      this._closeButton.interactive = false;
      this.visible = false;
      resourceManager.get(
        "sideMenu:sideMenuPanel:sideMenuContainer:buttonsContainer:settingsMenu:highlight"
      ).visible = false;

      // if we are closing because a ui modal told us to close don't leave modal mode
      if (event.reason === undefined) {
        messageBus.postImmediate("game:modal", {});
      }
    }
  }

  var settingsMenuCreator = function (json) {
    return new SettingsMenu(json);
  };

  var settingsMenuInitialiser = function (json) {};

  var settingsMenuFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "settingsMenu",
    settingsMenuCreator,
    settingsMenuInitialiser,
    settingsMenuFilesRequired
  );
})();
